<template>
  <div>
    <button
      class="commonButton t-full t-middle"
      :class="submitButtonAttr.class"
      :disabled="submitButtonAttr.disabled"
    >
      <span class="commonButton-inner">
        <i class="commonButton-innerIcon t-loading"></i>
        <span v-html="submitButtonAttr.text"></span>
      </span>
    </button>

    <ErrorMessages :error-messages="[field.errorText]" :has-error-messages="isFailedSubmitting" />
  </div>
</template>

<script>
import ErrorMessages from './ErrorMessages'

export default {
  name: 'SubmitButton',
  components: {
    ErrorMessages,
  },
  props: {
    field: {
      type: Object,
      required: true,
    },
    canSubmit: {
      type: Boolean,
      required: true,
    },
    isSubmitting: {
      type: Boolean,
      required: false,
      default: false,
    },
    isFailedSubmitting: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  computed: {
    submitButtonAttr() {
      if (this.isSubmitting) {
        return {
          text: this.field.loadingText || this.field.defaultText,
          class: 'is-visibleIcon',
          disabled: true,
        }
      } else if (this.canSubmit) {
        return {
          text: this.field.validText || this.field.defaultText,
          class: { 'is-failed': this.isFailedSubmitting },
        }
      } else {
        return {
          text: this.field.defaultText,
          disabled: true,
        }
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.commonButton {
  margin-top: 26px;
}
</style>
